<script>
import { Sprite, Container, BLEND_MODES } from 'pixi.js'
import SceneMixin from '@/mixins/Scene'

export default {
    name: 'Scene17',
    mixins: [ SceneMixin ],
    beforeDestroy() {
        console.log('beforeDestroy');
        _.each(this.$sprites, (sp, index)=>{
          if(this.$els[index]) this.$els[index]['container'].removeChild(sp)
        })
        this.$container.removeChild(this.$scene)
    },

    created() {

        const sprites = {}
        this.$sprites = sprites

        this.$scene = new Container 
        this.$scene.interactiveChildren = false
        
        this.$container.addChild(this.$scene)
        this.$parent.$scene17 = this.$scene

        const container = new Container()
        this.setCenterContainer(container)   
        this.$scene.addChild(container)

        const bkg_container = new Container()
        const bell_container = new Container()
              bell_container.y -= 792
        const zoom_container = new Container()
        const front_container = new Container()

        const fc1 = new Container()
        const fc2 = new Container()
        const fc3 = new Container()
        const fc4 = new Container()
        const fc5 = new Container()

        container.addChild(bkg_container)
        container.addChild(bell_container)
        container.addChild(zoom_container)
        container.addChild(front_container)

        bell_container.addChild(fc5)
        bell_container.addChild(fc4)
        bell_container.addChild(fc3)
        bell_container.addChild(fc2)
        bell_container.addChild(fc1)

        const sub1 = new TimelineMax()
        const sub2 = new TimelineMax()

        // ******************************************************** //
        // ******************************************************** //

        let medium = (this.$root.above('tablet')) 
            ? { ref: 'medium_17', container: zoom_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, scale: this.$root.$scale*2, y: -18 }
            : { ref: 'medium_half', container: zoom_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }, scale: this.$root.$scale_optimize*2, y: -18 }

        const els = { 
            'bg': { ref: 'gradiant', container: bkg_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }},
            'medium': medium,
            'clock': { container: front_container, alpha: 0, position: { x: 0, y: 0, width: 1536, height: 2160 }},
            'front': { ref: 'front_s17', container: zoom_container, alpha: 1, position: { x: 0, y: 0, width: 1536, height: 2160 }},
        }

        _.each(els, (el, name)=>{
          const _name = (el.ref) ? el.ref : name
          const sprite = new Sprite.from(this.$resources[_name].texture) 
                sprite.scale.set(this.$root.$scale)
                sprite.x -= this.$canvas_width/2
                sprite.y -= this.$canvas_height/2
                sprite.alpha = el.alpha
          el.container.addChild(sprite)
          sprites[name] = sprite
          this.applySettings(sprite, el)
        })

        this.$els = els

        // ******************************************************** //
        // ******************************************************** //

        const elements = [

            { name: 'check4_b100', nb: 6, container: fc1 },
            { name: 'check4_b64', nb: 20, container: fc2 },
            { name: 'check4_b38', nb: 20, container: fc3 },
            { name: 'check4_b50', nb: 4, container: fc4 },
            { name: 'check4_b30', nb: 30, container: fc5 },
            { name: 'check3_b100', nb: 6, container: fc1 },
            { name: 'check3_b64', nb: 20, container: fc2 },
            { name: 'check3_b38', nb: 20, container: fc3 },
            { name: 'check3_b50', nb: 4, container: fc4 },
            { name: 'check3_b30', nb: 30, container: fc5 },
            { name: 'check2_b100', nb: 6, container: fc1 },
            { name: 'check2_b64', nb: 20, container: fc2 },
            { name: 'check2_b38', nb: 20, container: fc3 },
            { name: 'check2_b50', nb: 4, container: fc4 },
            { name: 'check2_b30', nb: 30, container: fc5 },
            { name: 'check1_b100', nb: 6, container: fc1 },
            { name: 'check1_b64', nb: 20, container: fc2 },
            { name: 'check1_b38', nb: 20, container: fc3 },
            { name: 'check1_b50', nb: 4, container: fc4 },
            { name: 'check1_b30', nb: 30, container: fc5 },
            { name: 'b100', nb: 6, container: fc1 },
            { name: 'b64', nb: 20, container: fc2 },
            { name: 'b38', nb: 20, container: fc3 },
            { name: 'b50', nb: 4, container: fc4 },
            { name: 'b30', nb: 30, container: fc5 },
        ]

        _.each(elements, (data)=>{
            for(var i=1; i<data.nb+1; i++) {
                const name = data.name + '_'+ i
                let el = { container: data.container, alpha: 0, scale: this.$root.$scale }
                let sprite = new Sprite.from(this.$resources[data.name].texture)     
                    sprite.anchor.set(0.5)
                    sprite.alpha = el.alpha
                el.container.addChild(sprite)
                sprites[name] = sprite
                this.applySettings(sprite, el)
            }
        })

        // ******************************************************** //
        // ******************************************************** //

        const alphaFilter = new PIXI.filters.AlphaFilter(0.0)
        container.filters = [ alphaFilter ]
        TweenMax.to(alphaFilter, 1, { alpha: 1, ease: Linear.easeNone, onComplete: ()=>{ container.filters = null } })

        const appear = 33

        TweenLite.set(fc4, { pixi:{ blur: 0.75 } })
        TweenLite.set(fc5, { pixi:{ blur: 1.5 } })

        let py = -722
        const space = 278
        const level = []
        for(var i=0; i<20; i++){
            level[i] = py
            py -= space
        }

        const lf = -250
        const cl = -125
        const cr = 125
        const rg = 250
        const cc = 0

        const pos = [
            { name: 'b100_1', x: -187, y: 0 },
            { name: 'b100_2', x: 187, y: 0 },
            { name: 'b100_3', x: -187, y: -396 },
            { name: 'b100_4', x: 187, y: -396 },
            { name: 'b64_1', x: lf, y: level[0] },
            { name: 'b64_2', x: cc, y: level[0] },
            { name: 'b64_3', x: rg, y: level[0] },
            { name: 'b64_4', x: lf, y: level[1] },
            { name: 'b64_5', x: cc, y: level[1] },
            { name: 'b64_6', x: rg, y: level[1] },
            { name: 'b64_6', x: rg, y: level[1] },
            { name: 'b64_7', x: cc, y: level[2] },
            { name: 'b64_8', x: rg, y: level[3] },
            { name: 'b64_10', x: cc, y: level[4] },
            { name: 'b64_9', x: lf, y: level[5] },
            { name: 'b64_12', x: lf, y: level[8] },
            { name: 'b64_13', x: cc, y: level[10] },
            { name: 'b30_1', x: lf, y: level[6] },
            { name: 'b30_12', x: cc, y: level[7] },
            { name: 'b30_3', x: cl-(space*0.18), y: level[1]-space*0 },
            { name: 'b30_2', x: cr+(space*0.18), y: level[0]-space*0 },
            { name: 'b30_4', x: cr, y: level[4] },
            { name: 'b30_5', x: cr, y: level[3] },
            { name: 'b30_6', x: cl, y: level[12] },
            { name: 'b30_7', x: cl, y: level[13] },
            { name: 'b30_8', x: cl, y: level[8] },
            { name: 'b30_10', x: rg, y: level[10] },
            { name: 'b30_11', x: cr, y: level[9] },
            { name: 'b38_2', x: cc, y: level[15] },
            { name: 'b38_2', x: cc, y: level[3] },
            { name: 'b38_1', x: rg, y: level[7] },
            { name: 'b64_11', x: cc, y: level[6] },
            { name: 'b64_14', x: cc, y: level[13]-space*0.1 },
            { name: 'b50_1', x: cc-(space*0.36), y: level[0]+space*2.55 },
            { name: 'b50_2', x: cc+(space*0.36), y: level[0]+space*2.55 },
            { name: 'b50_3', x: cc-(space*0.36), y: level[1]+space*2.12 },
            { name: 'b50_4', x: cc+(space*0.36), y: level[1]+space*2.12 },
            { name: 'b30_18', x: cl-(space*0.18), y: level[0]-space*0 },
            { name: 'b30_19', x: cc, y: level[0]-space*0 },
            { name: 'b30_20', x: cr+(space*0.18), y: level[1]-space*0 },
            { name: 'b30_21', x: cc, y: level[1]-space*0 },

            { name: 'b100_5', x: 0, y: 594 },
        ]

        _.each(pos, (data, ref)=>{
            TweenMax.set(sprites[data.name], { x: data.x, y: data.y, alpha: 1 })
            TweenMax.set(sprites['check1_'+ data.name], {  pixi:{ x: data.x, y: data.y, alpha: 0,  scale:this.$root.$scale*0.8 } })
            TweenMax.set(sprites['check2_'+ data.name], {  pixi:{ x: data.x, y: data.y, alpha: 0,  scale:this.$root.$scale*0.8 } })
            TweenMax.set(sprites['check3_'+ data.name], {  pixi:{ x: data.x, y: data.y, alpha: 0,  scale:this.$root.$scale*0.8 } })
            TweenMax.set(sprites['check4_'+ data.name], {  pixi:{ x: data.x, y: data.y, alpha: 0,  scale:this.$root.$scale*0.8 } })
        })

        sub1
            .add([
                TweenMax.to(bell_container  , appear*1, { pixi:{ y: 4800-792  }, ease: Linear.easeNone }),
                TweenMax.to(fc1  , appear*0.9, { pixi:{ y: '-=250' }, ease: Linear.easeNone }),
                TweenMax.to(fc2  , appear*0.9, { pixi:{ y: '-=500' }, ease: Linear.easeNone }),
                TweenMax.to(fc4  , appear*0.9, { pixi:{ y: '-=750' }, ease: Linear.easeNone }),
                TweenMax.to(fc5  , appear*0.9, { pixi:{ y: '-=1000' }, ease: Linear.easeNone }),
                TweenMax.to(sprites['medium'], appear*0.25, { pixi:{ scale: this.$root.$scale_optimize*0.82 }, ease: Linear.easeNone, delay: appear*0.75 }),
                TweenMax.to(sprites['clock'], appear*0.1, { pixi:{ y: '-=16', scale: this.$root.$scale*2 }, ease: Linear.easeNone, delay: appear*0.90 }),
                TweenMax.to(sprites['clock'], appear*0.02, { pixi:{ alpha: 1 }, ease: Linear.easeNone, delay: appear*0.90 }),
                TweenMax.to(sprites['front'], appear*0.1, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.90 }),
            ])

        sub2
            .add([
                TweenMax.from(sprites['b100_5'], 1, { alpha: 0, ease: Linear.easeNone, delay: .25 }),
                TweenMax.from(sprites['b100_1'], 1, { alpha: 0, ease: Linear.easeNone, delay: 1 }),
                TweenMax.set(sprites['b100_2'], { alpha: 0 }),
                TweenMax.from(sprites['b50_1'], 1, { alpha: 0, ease: Linear.easeNone, delay: 5 }),
                TweenMax.from(sprites['b50_2'], 1, { alpha: 0, ease: Linear.easeNone, delay: 2.60 }),
                TweenMax.from(sprites['b100_3'], 1, { alpha: 0, ease: Linear.easeNone, delay: 6 }),
                TweenMax.from(sprites['b50_3'], 1, { alpha: 0, ease: Linear.easeNone, delay: 8 }),
                TweenMax.from(sprites['b50_4'], 1, { alpha: 0, ease: Linear.easeNone, delay: 9 }),
                TweenMax.from(sprites['b64_2'], 1, { alpha: 0, ease: Linear.easeNone, delay: 10 }),
                TweenMax.from(sprites['b64_3'], 1, { alpha: 0, ease: Linear.easeNone, delay: 11 }),
                TweenMax.from(sprites['b64_4'], 1, { alpha: 0, ease: Linear.easeNone, delay: 14 }),
                TweenMax.from(sprites['b64_5'], 1, { alpha: 0, ease: Linear.easeNone, delay: 10 }),
                TweenMax.from(sprites['b64_6'], 1, { alpha: 0, ease: Linear.easeNone, delay: 10 }),
                TweenMax.from(sprites['b30_18'], 1, { alpha: 0, ease: Linear.easeNone, delay: (appear*0.250)+.3 }),
                TweenMax.from(sprites['b30_19'], 1, { alpha: 0, ease: Linear.easeNone, delay: (appear*0.210)+.3 }),
                TweenMax.from(sprites['b30_20'], 1, { alpha: 0, ease: Linear.easeNone, delay: (appear*0.185)+.3 }),
                TweenMax.from(sprites['b30_21'], 2, { alpha: 0, ease: Linear.easeNone, delay: (appear*0.230)+.3 }),
                TweenMax.from(sprites['b30_4'], 2, { alpha: 0, ease: Linear.easeNone, delay: (appear*0.370)+.3 }),
                TweenMax.from(sprites['b30_5'], 2, { alpha: 0, ease: Linear.easeNone, delay: (appear*0.300)+.3 }),
                TweenMax.from(sprites['b64_8'], 2, { alpha: 0, ease: Linear.easeNone, delay: (appear*0.280)+.3 }),
                TweenMax.from(sprites['b30_10'], 2, { alpha: 0, ease: Linear.easeNone, delay: (appear*0.800)+.3 }),
                TweenMax.from(sprites['b30_11'], 2, { alpha: 0, ease: Linear.easeNone, delay: (appear*0.840)+.3 }),
                TweenMax.from(sprites['b30_1'], 2, { alpha: 0, ease: Linear.easeNone, delay: (appear*0.640)+.3 }),
                TweenMax.from(sprites['b30_12'], 1, { alpha: 0, ease: Linear.easeNone, delay: (appear*0.740)+.3 }),
            ])

        this.$tl.add([ sub1, sub2 ])

        const playBell = (ref)=>{
            let tml = new TimelineMax({})
                .set([sprites['check1_'+ pos[ref].name], sprites['check2_'+ pos[ref].name], sprites['check3_'+ pos[ref].name], sprites['check4_'+ pos[ref].name]], { pixi:{ alpha: 0, scale: this.$root.$scale*0.8 } })
                .staggerTo([sprites['check1_'+ pos[ref].name], sprites['check2_'+ pos[ref].name], sprites['check3_'+ pos[ref].name], sprites['check4_'+ pos[ref].name]] , 5, { pixi:{ alpha: 1, scale: this.$root.$scale*1 }, ease: Elastic.easeOut }, .25)

            TweenMax.delayedCall(2, ()=>{ tml.reverse() })
        }
     
        this.$tl.call(() => playBell(41), [], this, 1)
        this.$tl.call(() => playBell(0), [], this, 4)
        this.$tl.call(() => playBell(3), [], this, 6)
        this.$tl.call(() => playBell(5), [], this, 10)
        this.$tl.call(() => playBell(10), [], this, 11)
        this.$tl.call(() => playBell(13), [], this, 20)
        this.$tl.call(() => playBell(11), [], this, 16)
        this.$tl.call(() => playBell(22), [], this, 18)
        this.$tl.call(() => playBell(17), [], this, 25)
        this.$tl.call(() => playBell(25), [], this, 28)
        this.$tl.call(() => playBell(32), [], this, 30)
        this.$tl.call(() => playBell(31), [], this, 34)
        this.$tl.call(() => playBell(33), [], this, 35)

    },
    mounted() {

        // console.log('Scene17');
        // this.$parent.chapter.$tl.seek(84)
    
    }
}
</script>























